/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const Other = ({
    otherResearchDetails,
}: Partial<{
    otherResearchDetails: string;
}>) => (
    <Row>
        <ValueCell label="Details" value={otherResearchDetails} />
    </Row>
);

export default Other;
